import React, { Component } from 'react';
import { Container, Row, Col, Input } from 'reactstrap';

class PlayerGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      players: [
        { firstName: '', lastName: '', email: '', phone: '' },
        { firstName: '', lastName: '', email: '', phone: '' },
      ],
    };
  }

  handleInputChange = (index, field, value) => {
    const updatedPlayers = [...this.state.players];
    updatedPlayers[index][field] = value;
    this.setState({ players: updatedPlayers });
  };

  addPlayer = () => {
    this.setState((prevState) => ({
      players: [...prevState.players, { firstName: '', lastName: '', email: '', phone: '' }],
    }));
  };

  render() {
    const { players } = this.state;

    return (
      <Container>
        <Row>
          <Col><strong>First Name</strong></Col>
          <Col><strong>Last Name</strong></Col>
          <Col><strong>Email Address</strong></Col>
          <Col><strong>Phone Number</strong></Col>
        </Row>
        {players.map((player, index) => (
          <Row key={index} className="mb-2">
            <Col>
              <Input
                type="text"
                value={player.firstName}
                onChange={(e) => this.handleInputChange(index, 'firstName', e.target.value)}
                placeholder="First Name"
                required={index === 0} // First player's first name is required
              />
            </Col>
            <Col>
              <Input
                type="text"
                value={player.lastName}
                onChange={(e) => this.handleInputChange(index, 'lastName', e.target.value)}
                placeholder="Last Name"
                required={index === 0} // First player's last name is required
              />
            </Col>
            <Col>
              <Input
                type="email"
                value={player.email}
                onChange={(e) => this.handleInputChange(index, 'email', e.target.value)}
                placeholder="Email Address"
              />
            </Col>
            <Col>
              <Input
                type="tel"
                value={player.phone}
                onChange={(e) => this.handleInputChange(index, 'phone', e.target.value)}
                placeholder="Phone Number"
              />
            </Col>
          </Row>
        ))}
      </Container>
    );
  }
}

export default PlayerGrid;
